import { useRef, useState } from "react";
import axios from "axios";
import { saveCustomerSale, completeCustomerSale } from "../services/customerService";
import { toast } from "react-toastify";

const DEFAULT_LOAI_BANH = 0;

export const useCheckout = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const isProcessingRef = useRef(false);

  const runCheckout = async (checkoutFn) => {
    if (isProcessing || isProcessingRef.current) return false;
    if (typeof checkoutFn !== "function") return false;

    isProcessingRef.current = true;
    setIsProcessing(true);

    try {
      return await checkoutFn();
    } finally {
      isProcessingRef.current = false;
      setIsProcessing(false);
    }
  };

  const processCheckout = async ({
    orderItems = [],
    subtotal = 0,
    total = 0,
    discountPercent = 0,
    voucherDiscount = 0,
    voucherCode = "",
    usePointValue = 0,
    paymentMethod = "cash",
    cashGiven = "0",
    selectedTable = null,
    customerInfo: selectedCustomer,
    billNote = "",
    isPrintEnabled = true,
    isDisablePrintAPI = false,
    loaiBanh = DEFAULT_LOAI_BANH,
    onSuccess,
    onError,
  } = {}) => {
    return runCheckout(async () => {
      try {
        if (!Array.isArray(orderItems) || orderItems.length === 0) {
          toast.error("Vui long them san pham vao don hang");
          return false;
        }

        const MaNV = localStorage.getItem("MaNV") || "unknown_employee";
        const IDCH = localStorage.getItem("IDCH") || "unknown_store_id";
        const TenCuaHang = localStorage.getItem("TenCuaHang") || "Unknown Store";
        const TenNV = localStorage.getItem("TenUser") || "Unknown User";
        const ipBanhNgot = localStorage.getItem("IpBanhNgot") || "";

        let storedCustomerInfo = {};
        try {
          storedCustomerInfo = JSON.parse(
            localStorage.getItem("currentCustomerInfo") || "{}"
          );
        } catch {
          storedCustomerInfo = {};
        }

        if (selectedCustomer !== undefined) storedCustomerInfo = selectedCustomer || {};
        const TieuDiem = Math.max(0, Math.floor(Number(usePointValue) || 0));
        const HeSoTichDiem = storedCustomerInfo.HeSo_TichDiem ?? "0.02";
        const cashGivenValue = parseInt(cashGiven || "0", 10);
        const GiamTMTheVIP = voucherDiscount || 0;
        const GiamTienMat = 0;
        const discountFromPercent = subtotal * (discountPercent / 100);
        const totalAmount = Math.max(
          subtotal - (TieuDiem + GiamTMTheVIP + GiamTienMat + discountFromPercent),
          0
        );

        let phuongThucThanhToan = "0";
        let ghiChu = "Tien mat";

        switch (paymentMethod) {
          case "transfer":
            phuongThucThanhToan = "1";
            ghiChu = "Chuyen khoan";
            break;
          case "card":
            phuongThucThanhToan = "1.1";
            ghiChu = "Quet the";
            break;
          case "momo":
            phuongThucThanhToan = "1.2";
            ghiChu = "Vi Momo";
            break;
          case "vnpay":
            phuongThucThanhToan = "1.3";
            ghiChu = "Vi Vnpay";
            break;
          case "grab":
            phuongThucThanhToan = "1.4";
            ghiChu = "Grab";
            break;
          case "shopee":
            phuongThucThanhToan = "1.5";
            ghiChu = "Shopee";
            break;
          case "notPaid":
            phuongThucThanhToan = "2";
            ghiChu = "No";
            break;
          case "cash":
          default:
            phuongThucThanhToan = "0";
            ghiChu = "Tien mat";
            break;
        }

        const normalizeLineTotal = (item) =>
          item.ThanhTien !== undefined ? item.ThanhTien : item.price * item.quantity;

        const billDetails = {
          storeId: IDCH,
          totalAmount,
          cashGiven: cashGivenValue,
          change: cashGivenValue === 0 ? 0 : cashGivenValue - totalAmount,
          MaTheVIP: storedCustomerInfo?.MaKH || "",
          GiamPT: discountPercent,
          LoaiBanh: loaiBanh,
          GiamTienMat,
          GiamTMTheVIP,
          VoucherCode: voucherCode || "",
          employeeName: TenNV,
          TenKH: storedCustomerInfo?.Ten || "Khach le",
          MaKH: storedCustomerInfo?.MaKH || "",
          ipBanhNgot,
          HeSoTichDiem: HeSoTichDiem || "1",
          TieuDiem: TieuDiem || 0,
          PhuongThucThanhToan: phuongThucThanhToan,
          GhiChu: ghiChu,
          ...(localStorage.getItem("LoaiCH") === "0" && selectedTable
            ? { tableNumber: selectedTable }
            : {}),
          items: orderItems.map((item) => ({
            id: item.id,
            name: `${item.name}${item.unit ? " " + item.unit : ""}`,
            quantity: item.quantity,
            unitPrice: item.price,
            KmaiPT: item.KmaiPT || 0,
            ThanhTien: normalizeLineTotal(item),
            MXTY: item.MXTY || 0,
            LoaiBanh: loaiBanh,
            note: item.note || "",
          })),
          customerInfo: storedCustomerInfo?.MaKH ? storedCustomerInfo : undefined,
        };

        let puller = null;
        if (phuongThucThanhToan === "2") {
          puller = 0;
        } else if (
          ["1", "1.1", "1.2", "1.3", "1.4", "1.5"].includes(
            phuongThucThanhToan
          )
        ) {
          puller = 1;
        }

        const saveDBResponse = await saveCustomerSale("https://doticom.vn:3000", { billDetails, puller, LoaiBanh: loaiBanh });

        let pulling = null;
        const billId = saveDBResponse?.data?.billId || "";
        const printIDXuat =
          saveDBResponse?.data?.IDXuat ||
          saveDBResponse?.data?.idxuat ||
          billDetails.IDXuat ||
          billDetails.idxuat ||
          null;
        const billDetailsForPrint = printIDXuat
          ? { ...billDetails, IDXuat: printIDXuat, loyalty: saveDBResponse.data.loyalty }
          : billDetails;
        if (saveDBResponse.status === 200) {
          pulling = JSON.stringify(saveDBResponse.data.pull);
        }

        // Voucher usage belongs to the same transaction as the saved bill.

        const printBody = {
          billDetails: billDetailsForPrint,
          orderId: `HD${Date.now()}`,
          cashier: MaNV,
          items: orderItems.map((item) => ({
            id: item.id,
            name: `${item.name}${item.unit ? " " + item.unit : ""}`,
            quantity: item.quantity,
            unitPrice: item.price,
            note: item.note || "",
            isQR: false,
            Sale_OrderMR: "",
            ThanhTien: normalizeLineTotal(item),
            category: item.category || "Unknown",
            MaSP: item.id,
            VAT_SP: item.vat || 0,
            KmaiPT: item.KmaiPT || 0,
            LoaiBanh: loaiBanh,
          })),
          storeName: TenCuaHang,
          ipThuNgan: localStorage.getItem("IpBep"),
          ipBep: localStorage.getItem("IpBep"),
          pull: pulling,
          billId,
          IDXuat: printIDXuat,
          LoaiBanh: loaiBanh,
        };

        let taxInfo = null;
        let serviceNumberCounter = null;

        if (!isDisablePrintAPI) {
          try {
            const ipMayTinh = localStorage.getItem("IpMayTinh") || "doticom.vn";
            const printRes = await axios.post(`https://${ipMayTinh}/print`, printBody, {
              headers: { "Content-Type": "application/json" },
            });

            if (printRes?.data && typeof printRes.data === "object") {
              taxInfo = {
                invoiceNo: printRes.data.invoiceNo,
                invoiceSerial: printRes.data.invoiceSerial,
                mtc: printRes.data.mtc,
                taxOfficeCode: printRes.data.taxOfficeCode,
              };
              serviceNumberCounter = printRes.data.serviceNumberCounter || null;
            }
          } catch (err) {
            console.error("Print API error:", err.message);
            toast.error("Khong the in hoa don. Vui long kiem tra may in.");
          }
        }

        if (isPrintEnabled) {
          const taxHtml =
            taxInfo && taxInfo.invoiceNo
              ? `<hr/><div style="font-size:14px;"><b>Thong tin hoa don dien tu:</b><br/>So hoa don: <b>${taxInfo.invoiceNo}</b><br/>Ky hieu: <b>${taxInfo.invoiceSerial || ""}</b><br/>Ma tra cuu: <b>${taxInfo.mtc || ""}</b><br/>Ma CQ Thue: <b>${taxInfo.taxOfficeCode || ""}</b><div>*Phieu thanh toan chi co gia tri trong vong 120 phut va truoc 22h trong ngay mua hang</div></div>`
              : "";

          const diemTichLuyMoi = saveDBResponse.data.loyalty?.DiemConlai ?? "Chưa xác nhận";

          const billHtml = `
<html>
  <head>
    <title>Hoa don ban hang</title>
    <style>
      body { font-family: Arial, sans-serif; font-size: 16px; margin: 0; }
      h2 { text-align: center; }
      .stt { text-align: start; }
      table { width: 100%; border-collapse: collapse; margin-top: 10px; }
      th, td { border: 1px solid #ccc; padding: 4px 8px; text-align: left; }
      .total { font-weight: bold; font-size: 18px; }
      .promo-item { background-color: #e8f5e9; }
      @media print { body { margin: 0; } }
    </style>
  </head>
  <body>
    <div class="bill-copy">
      <h3>${TenCuaHang}</h3>
      <div>Ngay: ${new Date().toLocaleString()}</div>
      <div>Thu ngan: ${TenNV} - <b>Ma HD:</b> ${billId || "N/A"}</div>
      ${serviceNumberCounter ? `<h2 class="stt">So: ${serviceNumberCounter}</h2>` : ""}
      <hr/>
      <div><b>Khach hang:</b> ${storedCustomerInfo?.Ten || "Khach le"} <br/>
      ${storedCustomerInfo?.Ten ? `<b>SDT:</b> ${storedCustomerInfo?.SDT || storedCustomerInfo?.Sdt || ""}<br/><b>Diem tich luy:</b> ${diemTichLuyMoi.toLocaleString()}` : ""}</div>
      <hr/>
      <table>
        <thead><tr><th>San pham</th><th>SL</th><th>Don gia</th><th>Thanh tien</th></tr></thead>
        <tbody>${orderItems
          .map((item) => {
            const isPromo = item.KmaiPT === 100;
            const rowClass = isPromo ? ' class="promo-item"' : "";
            const displayName = isPromo ? `KM ${item.name}` : item.name;
            const thanhTien = normalizeLineTotal(item);
            return `<tr${rowClass}><td>${displayName}</td><td>${item.quantity}</td><td>${item.price.toLocaleString()}</td><td>${thanhTien.toLocaleString()}</td></tr>`;
          })
          .join("")}</tbody>
      </table>
      <hr/>
      <div>Tam tinh: ${subtotal.toLocaleString()} VND</div>
      ${discountPercent > 0 ? `<div>Giam gia: -${(subtotal * (discountPercent / 100)).toLocaleString()} VND</div>` : ""}
      ${voucherDiscount > 0 ? `<div>Voucher: -${voucherDiscount.toLocaleString()} VND</div>` : ""}
      ${usePointValue > 0 ? `<div>Tru diem: -${usePointValue.toLocaleString()} VND</div>` : ""}
      <div class="total">Thanh tien: ${total.toLocaleString()} VND</div>
      <hr/>
      <div>Cam on quy khach!</div>
      <div style="margin-top: 4px; font-weight: 500; color: #000; font-size: 14px;">${billNote || ghiChu ? `Note: ${billNote ? billNote.replace(/\n/g, "<br/>") : ""}${billNote && ghiChu ? " - " : ""}${ghiChu || ""}` : ""}</div>
      <hr/>
      ${taxHtml}
    </div>
    <script>window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 500); };</script>
  </body>
</html>`;

          const printWindow = window.open("", "_blank", "width=400,height=600");
          if (printWindow) {
            printWindow.document.write(billHtml);
            printWindow.document.close();
          }
        }

        toast.success(`Luu don hang thanh cong! Tong: ${total.toLocaleString()} VND`);
        onSuccess?.();
        completeCustomerSale(IDCH);
        return true;
      } catch (err) {
        console.error("Checkout error:", err);
        toast.error(
          "Co loi khi luu hoa don: " + (err.response?.data?.message || err.message)
        );
        onError?.(err);
        return false;
      }
    });
  };

  return {
    isProcessing,
    runCheckout,
    processCheckout,
  };
};
